import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import axios from 'axios';
import Loading from '../../components/Loading';
import NoResult from '../../components/general/NoResult';
import BillingInformation from './form/BillingInformation.js';
import SplitRows from '../../components/general/SplitRow.js';
import OptionColumn from '../../components/general/OptionColumn.js';
import Notification from '../../components/Notification.js'
import General from '../../modules/General';
import EstimatePackageUsage from "../../components/widgets/EstimatePackageUsage";
import {setGlobalKey} from '../../actions/General.js';
import moment from 'moment';
class Settings extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
            pickTier:false,
		    estimate:false,
            forceReload:false,
            tier:3,
            tiers:[],
			'packages':[],
			'isLoading':true,
            step:0,
			'selected_packages':{},
			'error':false,
			'isPaying':false,
			'promo_code':'',
			'promo':false,
		}
		this.handleSubmit = this.handleSubmit.bind(this);
		this.changePackage = this.changePackage.bind(this);
		this.renderDemoExpired = this.renderDemoExpired.bind(this);
		this.applyPromo = this.applyPromo.bind(this);
		this.handlePromoChange = this.handlePromoChange.bind(this);
	}

    handlePromoChange(e) {
		this.setState({
			promo_code:e.target.value
		})
	}

    applyPromo() {
		if(this.state.promo_code == '') {
            Notification.error('No promo code added');
			return;
		}
        this.setState({
            isLoading:true,
        })

		axios.get('/subscriptions/promo?code='+this.state.promo_code).then(res => {
            this.setState({
                isLoading:false,
				promo:res.data,
            });
		}).catch(err => {
            this.setState({
                isLoading:false,
            })
			Notification.error('Invalid promo code');
		});
	}

	selectedPackage() {
		return this.state.selected_packages;
	}

	changePackage() {
		this.setState({
            step:0
		});
	}

	selectPackage(package_id) {
		this.setState({'package':package_id});
	}

	handleSubmit(values) {
		this.setState({
			'isPaying':true
		});

        this.props.setGlobalKey('showProcessing',true);

        Stripe.createToken({
            number: values.cardnumber,
            cvc: values.cvc,
            exp_month: values.month,
            exp_year: values.year,
        }, (status, response) => {
            if (response.error) {
                this.props.setGlobalKey('showProcessing',false);
                this.setState({isPaying:false,error:response.error.message});
            } else {
            	values.token = response['id'];
            	values.packages = this.state.selected_packages;
            	if(this.state.promo_code) {
                    values.promo_code = this.state.promo_code;
                }

                axios.post('/subscriptions',values)
                .then(res => {
                	this.setState({
						'isPaying':false,
                        forceReload:true,
					});
                    Notification.success('Thanks! You are now subscribed.');
                    this.props.setGlobalKey('showProcessing',false);
                    this.props.router.push(General.Link('/settings/billing'));
                }).catch(err => {
                    this.props.setGlobalKey('showProcessing',false);
                    this.setState({isPaying:false,error:err.response.data.error.message});
                })
            }
        });
	}

	componentWillMount() {
        General.fetchGeneral().then(() => {
            if (this.props.general.account.dealer) {
                this.props.router.push(General.Link('/settings/billing/dealer'));
                return;
            }
            axios.get('/packages').then(res => {
                this.setState({
                    'isLoading': false,
                    'packages': res.data.plans,
                    'tiers': res.data.tiers,
                });
            });

            if (this.props.general.plans.length > 0) {
                let selected_packages = {};
                let tier = 0;

                this.props.general.plans.map(plan => {
                    if (plan.plan.ends_at) {
                        tier = plan.details.tier;
                        return plan;
                    }
                    selected_packages[plan.details.type] = plan.details;
                    tier = plan.details.tier;
                });

                this.setState({
                    selected_packages,
                    tier
                });
            }
        });
	}

	hasDiffFromExistingSelection = () => {
        let current = [];
        let i = 0;

        this.props.general.plans.map(plan => {
            if(plan.plan.ends_at) {
                return plan;
            }
            i++;
            current.push(plan.details.type);
        });

        let found = 0;

        Object.keys(this.state.selected_packages).map(k => {
            if(current.includes(k)) {
                found++;
            }else{
                found--;
            }
        })

        if(Object.keys(this.state.selected_packages).length == 0) {
            return false;
        }

        return found != i;

    }

	componentDidMount() {


        if(this.props.general.account.dealer) {
            this.props.router.push(General.Link('/settings/billing/dealer'));
            return;
        }
	}

	renderDemoExpired() {
		if(this.props.general.account.expired == true) {
			return (
                <div role="alert" className="alert dark alert-danger alert-dismissible">
					<h4>Subscription expired</h4>
					<p>
                        Your subscription has expired. To continue using our service you need to subscribe.
					</p>
					<p className="m-t-15">
						<Link to={General.Link('/settings/billing/invoices')} className="btn btn-danger btn-inverse btn-outline">Click here to see previous invoices</Link>
					</p>
				</div>
			)
		}
	}

	hasSelectedSubscriptionType = (type) => {
	    if(typeof this.state.selected_packages[type] != 'object') {
	        return false;
        }

        return true;
    }

    getPackageData = (type) => {
        return this.state.selected_packages[type];
    }

    addFeature = (type,i = 0) => {
	    let p;

	    if(i == 0) {
	        p = this.state.packages[type][this.getPackageWithTier(type,this.state.tier).i];
        }else{
            p = this.state.packages[type][i];
        }

	    this.setState({
            selected_packages:{
                ...this.state.selected_packages,
                [type]:p
            }
        })
    }

    removeFeature = (type) => {
	    let packages = {
            ...this.state.selected_packages
        };

	    delete packages[type];

        this.setState({
            selected_packages:packages
        })
    }

    handlePlanDropdownChange = (type,e) => {
	    this.addFeature(type,e.target.value);
    }

	listPackageType = (key) => {
	    let p = this.state.packages[key];
        let name = key.charAt(0).toUpperCase() + key.substr(1);
        let description = '';

        switch (key) {
            case 'platform':
                description = 'The base Crall.io platform. Features may include chat, popups, emails, analytics, etc depending on package.';
            break;
            case 'recommendation':
                description = 'Show personalized product recommendations in your shop and include them in e-mails.';
            break;

            case 'search':
                description = 'Enable personalized search in your shop.';
            break;
        }

        if(!this.hasSelectedSubscriptionType(key)) {
            return (
                <tr key={key}>
                    <td style={{backgroundColor:'#f7f7f7','color':'#000'}}>
                        <strong>{name}</strong>
                        <br />{description}
                    </td>
                    <td style={{textAlign:'center',backgroundColor:'#f7f7f7',verticalAlign:'middle'}}></td>
                    <td style={{textAlign:'center',backgroundColor:'#f7f7f7',verticalAlign:'middle'}}></td>
                    <td style={{textAlign:'center',backgroundColor:'#f7f7f7',verticalAlign:'middle'}}></td>

                    <td style={{textAlign:'right',backgroundColor:'#f7f7f7',verticalAlign:'middle'}}>
                        <div className="checkbox-custom checkbox-primary">
                            <input onClick={() => this.addFeature(key)} type="checkbox" defaultChecked={false}   />
                                <label></label>
                        </div>
                    </td>
                </tr>
            )
        }


        return (
            <tr key={key}>
                <td>
                    <strong>{name}</strong>
                    <br />{description}
                </td>
                <td style={{verticalAlign:'middle'}}>{this.getPackageData(key).sessions}*</td>
                <td style={{verticalAlign:'middle'}}>{this.getPackageData(key).emails}</td>
                <td style={{verticalAlign:'middle'}}>{this.getPackageData(key).price}</td>
                <td style={{textAlign:'right',verticalAlign:'middle'}}>
                    <div className="checkbox-custom checkbox-primary">
                        <input onClick={() => this.removeFeature(key)} type="checkbox" defaultChecked={true}  />
                        <label></label>
                    </div>
                </td>
            </tr>
        )
    }

    totalSum = () => {
        let sum = 0;
        for(let i in this.state.selected_packages) {
            sum += this.state.selected_packages[i].amount;
        }

        return sum;
    }

    continue = () => {
        this.setState({
            step:(this.state.step+1),
        })
    }

    previous = () => {
        this.setState({
            step:(this.state.step-1),
        })
    }

    calculatePrice = () => {
	    let sum = this.totalSum();

        if(this.props.general.account.country == 'Norway') {
	        sum = 'NOK '+sum+',- ex tax / month';
        }else{
	        sum = '$'+sum+' / month';
        }

        return sum;
    }

    sumToPay = () => {
	    return this.totalSum();
    }

    getPackageWithTier = (type,tier) => {
        for(let i in this.state.packages[type]) {
            if(this.state.packages[type][i].tier == tier && !this.state.packages[type][i].deprecated) {

                return {
                    i:i,
                    package:this.state.packages[type][i],
                };
            }
        }

        return {
            i:0,
            package:this.state.packages[type][0],
        };
    }

    skipEstimate = () => {
        this.setState({
            pickTier:true,
        })
    }

    update = () => {
	    if(Object.keys(this.state.selected_packages).length == 0) {
	        Notification.error("If you want to remove all features, you must cancel you account.");
	        return;
        }

        this.props.setGlobalKey('showProcessing',true);

        axios.put(`/subscriptions`,{
            packages:this.state.selected_packages,
        }).then((res) => {
            this.setState({
                forceReload:true,
            })
            Notification.success('Thanks! Your plan has been updated.');
            this.props.setGlobalKey('showProcessing',false);
            this.props.router.push(General.Link('/settings/billing'));
        });
    }

    getPackageWithSession = (type,sessions) => {
        for(let i in this.state.packages[type]) {
            if(this.state.packages[type][i]['sessions'] == sessions) {
                return {
                    i:i,
                    package:this.state.packages[type][i],
                };
            }
        }

        return {
            i:0,
            package:this.state.packages[type][0],
        };
    }

    handleEstimateResult = (result) => {
	    this.setState({
            estimate:result,
            tier:result.tier,
            pickTier:true,
        });

	    this.addFeature('platform',this.getPackageWithSession('platform',result.sessions).i);
	    this.addFeature('recommendation',this.getPackageWithSession('recommendation',result.sessions).i);
	    this.addFeature('search',this.getPackageWithSession('search',result.sessions).i);
    }

    isOnDisabledPlan = () => {
	    let disabled = false;

        this.props.general.plans.map(plan => {
            if(!disabled) {
                disabled = plan.details.disabled;
            }
        });

        return disabled;
    }

    handleTierChange = (e) => {
	    this.setState({
            tier:e.target.value,
        })
    }

    pageActions = () => {
        return (
            <div className="page-header-actions">

            </div>
        )
    }

    isSwitchingFromDeprecatedPlan = () => {
	    let result = false;

	    Object.keys(this.state.selected_packages).map(type => {
	        this.props.general.plans.map(plan => {
	            if(type == plan.details.type && plan.plan.plan_id != this.state.selected_packages[type].id) {
                    result = true;
                }
            });
        });

        return result;
    }

	render() {

		if(this.state.isLoading) {
			return (
				<Loading error={false} />
			);
		}

		if(this.state.step == 2) {
			return (
				<div className="full-height">
				<div className="page-header">
					<span className="page-title"><i className="icon wb-payment"></i> Billing</span>
                    {this.pageActions()}
				</div>

				<div className="page-content">
					{this.renderDemoExpired()}
					<BillingInformation handlePromoChange={this.handlePromoChange} promo={this.state.promo} applyPromo={this.applyPromo} promo_code={this.state.promo_code} isPaying={this.state.isPaying} errorMessage={this.state.error} p={this.selectedPackage()} changePackage={this.changePackage} sumToPay={this.sumToPay} onSubmit={this.handleSubmit} />
				</div>
			</div>
			);
		}



		return (

				<div className="full-height">
				<div className="page-header">
					<span className="page-title"><i className="icon wb-payment"></i> Billing</span>
                    {this.pageActions()}
                </div>

				<div className="page-content">
					{this.renderDemoExpired()}

                    <div className="row">
                        <div className="col-sm-12 inherit-position">
                            <div className="panel panel-bordered" style={{border: "1px solid #e4eaec"}}>
                                <div className="panel-body">
                                    {
                                        this.state.step == 0 && this.props.general.plans.length == 0 ?
                                            <div style={{marginBottom:'20px'}}>
                                                <EstimatePackageUsage handleResult={this.handleEstimateResult} packages={this.state.packages}>
                                                    <strong>Package size estimation</strong><br />
                                                    Our packages are limited by the amount of unique sessions you have each month. It can be difficult to figure out how many sessions you need as a new customer.<br />
                                                    After analyzing our data from existing customers we can give an estimate of how many sessions you'll need based on data from Google Analytics.<br /><br />

                                                    We can try to estimate the amount of sessions you'll need based on your Google Analytics numbers.<br />
                                                    You can read more about sessions and how to find your Analytic sessions <a href="http://docs.crall.io/ofte-stilte-sporsmal/hva-er-sessions" target="blank">by clicking here.</a>
                                                    {
                                                        this.state.pickTier ?
                                                            <div className="row">
                                                                <div className="col-sm-5 offset-sm-3 m-t-20 m-b-20">
                                                                    <h2>Session estimate</h2>
                                                                    <select className="form-control" value={this.state.tier} onChange={this.handleTierChange}>
                                                                        {
                                                                            this.state.tiers.map((tier,i) => {
                                                                                return <option value={tier.tier} key={i}>{tier.name}</option>
                                                                            })
                                                                        }
                                                                    </select>
                                                                    <br />
                                                                    <button className="btn btn-dark btn-block" onClick={this.continue}>Continue with selected sessions</button>
                                                                </div>
                                                            </div>
                                                            :null
                                                    }
                                                </EstimatePackageUsage>
                                                <div style={{width:'100%',textAlign:'center'}}>
                                                    <a onClick={(e) => {e.preventDefault();this.skipEstimate()}} href="javascript:void(0)">... or click here to skip estimation</a>
                                                </div>
                                            </div>
                                        :
                                            <div>
                                                {
                                                    Object.keys(this.state.selected_packages).length == 0 && this.props.general.plans.length > 0 && !this.props.general.account.isOnGracePeriod ?
                                                        <div role="alert" className="alert dark alert-danger alert-dismissible">
                                                            <h4>No features selected</h4>
                                                            <p>
                                                                To use our service you must subscribe to at least one feature. If you wish to cancel your account, please use this link.
                                                            </p>
                                                            <p className="m-t-15">
                                                                <Link to={General.Link('/settings/billing/cancel')} className="btn btn-danger btn-inverse btn-outline">Cancel account</Link>
                                                            </p>
                                                        </div>
                                                        :null
                                                }

                                                {
                                                    this.isSwitchingFromDeprecatedPlan() ?
                                                        <div role="alert" className="alert dark alert-warning alert-dismissible">
                                                            <h4>Deprecated Plan</h4>
                                                            <p>
                                                                You are now switching from a deprecated Plan. If you do this you'll not be able to resubscribe with the same plan. If you wish to resubscribe at a later time you must select one of our current plans.
                                                            </p>
                                                        </div>
                                                        :null
                                                }

                                                {
                                                    this.props.general.account.isOnGracePeriod ?
                                                        <div role="alert" className="alert dark alert-danger alert-dismissible">
                                                            <h4>Account cancelled</h4>
                                                            <p>
                                                                You have cancelled your account and it will expire <strong>{moment.utc(this.props.general.account.isOnGracePeriod).local().format('DD-MM-YYYY')}</strong>.
                                                                If you want to continue using our services, please resubscribe with the services you want to use in the form below.
                                                            </p>
                                                        </div>
                                                        :null
                                                }

                                                {
                                                    this.isOnDisabledPlan() ?
                                                        <div role="alert" className="alert dark alert-danger alert-dismissible">
                                                            <h4>Disabled plan</h4>
                                                            <p>
                                                                You are currenly subscribed to an old plan/feature that is not available anymore. <br />If you wish to upgrade / subscribe to additional features please contact us by chat or drop us a line at hi@crall.io.
                                                            </p>
                                                        </div>:null
                                                }

                                                {
                                                    !this.isOnDisabledPlan() ?
                                                        <table className="table" style={{marginTop:'20px'}}>
                                                            <thead>
                                                            <tr>
                                                                <th style={{width:'30%'}}>Product</th>
                                                                <th>Max session usage</th>
                                                                <th>E-mails</th>
                                                                <th>Price</th>
                                                                <th style={{textAlign:'center'}}>Subscribe to</th>
                                                            </tr>
                                                            </thead>
                                                            <tbody>
                                                            {
                                                                Object.keys(this.state.packages).map((key) => {
                                                                    return this.listPackageType(key);
                                                                })
                                                            }
                                                            <tr>
                                                                <td style={{fontWeight:'bold',backgroundColor:'#f0f0f0'}}>Total price</td>
                                                                <td style={{backgroundColor:'#f0f0f0'}}></td>
                                                                <td style={{backgroundColor:'#f0f0f0'}}></td>
                                                                <td style={{fontWeight:'bold',backgroundColor:'#f0f0f0'}}>{this.calculatePrice()}</td>
                                                                <td style={{backgroundColor:'#f0f0f0'}}></td>
                                                            </tr>
                                                            <tr>
                                                                <td>* Sessions are not added together when subscribing to multiple features.</td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                            </tr>
                                                            </tbody>
                                                        </table>
                                                    :null
                                                }

                                                <div className="col-sm-12 p-0">
                                                    <div className="col-sm-6 p-0" style={{textAlign:'left'}}>
                                                        {
                                                            this.props.general.plans.length > 0 ?
                                                                <div>
                                                                    - <span>We are billing your <strong>{this.props.general.account.card_brand}</strong> ending in <strong>{this.props.general.account.card_last_four}</strong> - <Link to={General.Link('/settings/billing/card')} >Click here to update card</Link></span><br />
                                                                    {
                                                                        !this.props.general.account.isOnGracePeriod ?
                                                                            <span>- <span>Do you want to <strong>cancel</strong> your account? - <Link to={General.Link('/settings/billing/cancel')} >Click here</Link></span></span>:null}
                                                                </div>
                                                                :
                                                                <button className="btn btn-dark" onClick={this.previous}>Back to estimate</button>
                                                        }
                                                    </div>
                                                    <div className="col-sm-6 p-0" style={{textAlign:'right'}}>
                                                        {
                                                            this.props.general.plans.length > 0 ?
                                                                <button className="btn btn-dark" onClick={this.update} disabled={!this.hasDiffFromExistingSelection()}>Update subscription</button>
                                                                :
                                                                <button className="btn btn-dark" onClick={this.continue} disabled={this.totalSum() === 0 ? true:false}>Continue to billing details</button>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                    }


                                </div>
                            </div>
                        </div>
                    </div>


				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		auth:state.auth,
		general:state.general,
	}
}

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({setGlobalKey},dispatch)
}


Settings = connect(mapStateToProps,mapDispatchToProps)(Settings);
export default Settings;



// WEBPACK FOOTER //
// ./containers/settings/BillingSubscribe.js